import { IdentityProvider, IOIDCIdp, ISAMLIdp, SAMLIdpUpdateFields } from "../../../../domain/IdentityProvider";
import { Attention, Disclose } from "@optimizely/axiom";
import { SSOConnectionDetails } from "../SSOConnectionDetails/SSOConnectionDetails";
import React, { useState } from "react";
import { OIDC, SAML, UNEXPECTED_ERROR } from "../../../../constants/constants";
import { SSOOIDCFormFields } from "../SSOOIDCForm/SSOOIDCFormFields/SSOOIDCFormFields";
import { SSOSamlFormFields } from "../SSOSamlForm/SSOSamlFormFields/SSOSamlFormFields";

export const IdentityProviderDisclosure = ({
    identityProvider,
    onRemove,
    onUpdate,
    onCertificateUpload,
    showWarningWhenRemoving = false
}: {
    identityProvider: IdentityProvider;
    onRemove: () => Promise<void>;
    onUpdate: (updatedData: SAMLIdpUpdateFields) => Promise<void>;
    onCertificateUpload: ({
        certificate,
        identityProviderId
    }: {
        certificate: File;
        identityProviderId: string;
    }) => Promise<void>;
    showWarningWhenRemoving?: boolean;
}) => {
    const { idpName = "Connection", type } = identityProvider;
    const [error, setError] = useState(null);

    const handleConnectionRemoval = async () => {
        return onRemove().catch((e) => {
            setError(e?.message || UNEXPECTED_ERROR);
        });
    };

    return (
        <Disclose title={idpName}>
            {error && <Attention type="bad-news">{error}</Attention>}
            {type === SAML && <SSOSamlFormFields disabled idp={identityProvider as ISAMLIdp} />}
            {type === OIDC && <SSOOIDCFormFields disabled idp={identityProvider as IOIDCIdp} />}
            <SSOConnectionDetails
                className="push-quad--top"
                identityProvider={identityProvider}
                onRemove={handleConnectionRemoval}
                onUpdate={onUpdate}
                onCertificateUpload={onCertificateUpload}
                showWarningWhenRemoving={showWarningWhenRemoving}
            />
        </Disclose>
    );
};

IdentityProviderDisclosure.displayName = "IdentityProviderDisclosure";
